module.exports = __webpack_public_path__ + "img/4985ad4384954c30c4e2c9bface9b8ec.png";